var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "54_Favorites",
    transform: "translate(-971, -115)",
    fill: "#738089",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(961, 102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_search",
    transform: "translate(10, 13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8674455,13.2383501 L10.2528,9.68153599 C11.1993594,8.65314672 11.7809566,7.29308614 11.7809566,5.79648192 C11.7804991,2.59496952 9.14345562,0 5.89024953,0 C2.63704344,0 0,2.59496952 0,5.79648192 C0,8.99799431 2.63704344,11.5929638 5.89024953,11.5929638 C7.29585985,11.5929638 8.58505465,11.1067916 9.59770257,10.2985329 L13.226371,13.8693697 C13.4031789,14.0435434 13.6902258,14.0435434 13.8670337,13.8693697 C14.0442534,13.6952188 14.0442534,13.4125238 13.8674455,13.2383501 Z M5.89024953,10.7011411 C3.13768274,10.7011411 0.906297817,8.50525686 0.906297817,5.79648192 C0.906297817,3.08770697 3.13768274,0.891822758 5.89024953,0.891822758 C8.6428392,0.891822758 10.8742012,3.08770697 10.8742012,5.79648192 C10.8742012,8.50525686 8.6428392,10.7011411 5.89024953,10.7011411 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.0404024b5c0990f1e2c68cb5f4e73e70.svg";
export { ForwardRef as ReactComponent };